/* Dogs Trust Gifts: hero carousel (bychamberlain, 2026)
   Lightweight, dependency-free slideshow for the dt-hero section.
   - Autoplay on a configurable timer (data-autoplay, seconds; 0 = off)
   - Prev/next arrows, dots, touch swipe and keyboard arrows
   - Pauses on hover/focus/touch; respects prefers-reduced-motion
   Multiple carousels per page are supported (each initialises independently). */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (root.dataset.dtCarouselReady === 'true') return;
    root.dataset.dtCarouselReady = 'true';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track || slides.length < 2) return; // nothing to rotate

    var index = 0;
    var count = slides.length;
    var interval = parseFloat(root.dataset.autoplay || '0') * 1000;
    var timer = null;

    function update() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var current = i === index;
        d.setAttribute('aria-current', current ? 'true' : 'false');
        d.classList.toggle('is-active', current);
      });
    }

    function goTo(i) {
      index = (i + count) % count;
      update();
    }
    function nextSlide() { goTo(index + 1); }
    function prevSlide() { goTo(index - 1); }

    function start() {
      if (REDUCED || !interval) return;
      stop();
      timer = window.setInterval(nextSlide, interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    if (next) next.addEventListener('click', function () { nextSlide(); restart(); });
    if (prev) prev.addEventListener('click', function () { prevSlide(); restart(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); restart(); });
    });

    // Pause while the user is interacting.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Keyboard arrows when the carousel has focus.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { nextSlide(); restart(); }
      else if (e.key === 'ArrowLeft') { prevSlide(); restart(); }
    });

    // Swipe: Pointer Events cover touchscreens at every viewport (phones,
    // tablets, touchscreen laptops on the desktop layout) plus mouse drag;
    // touch events remain as a fallback for older browsers. After a real
    // swipe, the next click is suppressed so swiping across a linked banner
    // doesn't navigate.
    var startX = 0, startY = 0, swiping = false, suppressClick = false;
    function swipeStart(x, y) { swiping = true; startX = x; startY = y; stop(); }
    function swipeEnd(x, y) {
      if (!swiping) return;
      swiping = false;
      var dx = x - startX;
      var dy = y - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 400);
        if (dx < 0) nextSlide(); else prevSlide();
      }
      start();
    }
    if (window.PointerEvent) {
      track.addEventListener('pointerdown', function (e) {
        if (e.button === 0) swipeStart(e.clientX, e.clientY);
      });
      track.addEventListener('pointerup', function (e) { swipeEnd(e.clientX, e.clientY); });
      track.addEventListener('pointercancel', function () { swiping = false; start(); });
    } else {
      track.addEventListener('touchstart', function (e) {
        swipeStart(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        swipeEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      }, { passive: true });
    }
    root.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Pause when the tab/section is not visible.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    update();
    start();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-dt-carousel]'))
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is edited/added in the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();
